<template>
  <div class="campaigns">
    <div class="inner-content">
      <h1>Национален Съвет</h1>

      <div class="campaigns-list">
        <article v-for="campaign in campaigns" class="campaign-preview" :key="campaign.ID">
          <router-link :to="{ name: 'nc-campaign', params: {slug: decodeURIComponent(campaign.slug)} }">
            <img :src="campaign.icon" class="campaign-icon">
            <h3 v-html="campaign.title.rendered"></h3>
          </router-link>
        </article>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'CampaignsList',

  asyncData ({ store }) {
    return store.dispatch('getNCCampaigns')
  },

  mounted () {
    if (typeof this.$store.getters.nationalCouncilCatId === 'undefined') {
      this.$store.dispatch('getNationalCouncilCategoryId').then(() => {
        this.$store.dispatch('getNCCampaigns')
      })
    } else {
      this.$store.dispatch('getNCCampaigns')
    }
  },

  computed: {
    campaigns () {
      return this.$store.getters.campaigns
    }
  }
}
</script>
